import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import RegisterForm from "./components/RegisterForm";
import AdminLogin from "./components/AdminLogin";
import AdminUserList from "./components/AdminUserList";
import AdminPanel from "./components/AdminPanel";
import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import ResetPassword from "./components/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Cancelled from "./pages/Cancelled";
import TrialPreRegisterPage from "./pages/TrialPreRegisterPage";
import ImmediateSubscribePage from "./pages/ImmediateSubscribePage";
import AfterCheckout from "./pages/AfterCheckout";
import WaitPage from "./pages/WaitPage";
import ManualPage from "./pages/ManualPage";
import ContactPage from "./pages/ContactPage";
import AppFooter from "./components/AppFooter";
import Terms from "./pages/Terms";
import Tokushoho from "./pages/Tokushoho";
import PrivacyOAuth from "./pages/PrivacyOAuth";
import SalesLetterPage from "./pages/SalesLetterPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 一般ユーザー */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cancelled" element={<Cancelled />} />
        <Route path="/subscribe/trial" element={<TrialPreRegisterPage />} />
        <Route path="/subscribe/reuse" element={<ImmediateSubscribePage />} />
        <Route path="/after-checkout" element={<AfterCheckout />} />
        <Route path="/wait" element={<WaitPage />} />
        <Route path="/manual" element={<ManualPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/tokushoho" element={<Tokushoho />} />
        <Route path="/privacy-oauth" element={<PrivacyOAuth />} />
        <Route path="/letter" element={<SalesLetterPage />} />

        {/* 管理者 */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/users"
          element={
            <ProtectedAdminRoute>
              <AdminUserList />
            </ProtectedAdminRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;